import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["textContent"]

import { PropType } from 'vue';
import { HardwareComponent } from '@/models/hardware.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'Property',
  props: {
  component: {
    type: Object as PropType<HardwareComponent>,
    required: true,
  },
  property: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  suffix: {
    type: String,
  },
},
  setup(__props) {

const { component, property, label, suffix } = __props;



return (_ctx: any,_cache: any) => {
  return (__props.component.getPropertyValue(__props.property))
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(`property ${__props.label ? 'property-block' : ''}`)
      }, [
        (__props.label)
          ? (_openBlock(), _createElementBlock("strong", {
              key: 0,
              textContent: _toDisplayString(__props.label)
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(__props.component.getPropertyValue(__props.property)) + _toDisplayString(__props.suffix), 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})